import { useTransferFacets } from './use-transfers';

import {
  useCatalogGeoFilters,
  useSelectedCountryId,
  type CatalogGeoFilters,
} from '@/hooks/use-catalog-geo-filters';

/**
 * Builds the Country + City list-filters shared by the Transfers Listing grid
 * and the Media bulk-assign tool (which uses the Country half only). Options
 * come from the transfer facets endpoint - i.e. only places actually in use by
 * transfers, refreshed as new transfers are added. City narrows to whatever
 * Country is selected.
 */
export function useTransferGeoFilters(): CatalogGeoFilters {
  const facets = useTransferFacets();
  return useCatalogGeoFilters(facets.data, useSelectedCountryId());
}
